import QRCode from 'qrcode.react';
import { refWidth } from 'desktop/utils/dimensions';
import styled from 'styled-components';

const DOWNLOAD_PATH = '/download';

const ResponsiveSvgWrapper = styled.div`
  svg {
    display: block;
    height: auto;
    width: ${refWidth(110)}vw;
  }
`;

const QRCodeWrapper = () => {
  return (
    <ResponsiveSvgWrapper>
      <QRCode renderAs={'svg'} value={`${window.location.origin}${DOWNLOAD_PATH}`} />
    </ResponsiveSvgWrapper>
  );
};

export default QRCodeWrapper;
